<ui-object-navigation-main-page alias="ad"></ui-object-navigation-main-page>